import { Component, Input, HostListener, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Toast } from '../toast/toast.service';
import { ImageService } from 'app/shared/services/image/image.service';

@Component({
  selector: 'tog-draggable-image-wrapper',
  templateUrl: './draggable-image-wrapper.component.html',
  styleUrls: ['./draggable-image-wrapper.component.scss']
})
export class DraggableImageWrapperComponent {
  @Input() active: boolean = true;
  @Input() cropperName: string = '';
  @Input() maxFileSize: number = 512;

  dropStateActive: boolean = false;
  allowDragLeave: boolean = false;

  @Output() fileDropped: EventEmitter<File> = new EventEmitter<File>();
  @Output() invalidFileType = new EventEmitter();
  @Output() maxFileSizeExceeded = new EventEmitter();

  @ViewChild('imageUpload') imageUpload: ElementRef;

  constructor(private toast: Toast, public imageService: ImageService) { }

  showFilePicker() {
    this.imageUpload.nativeElement.click();
  }

  imageSelected(e: any) {
    if (e.target && e.target.files) {
      this.readFileForImage(e.target.files[0]);
    }
  }

  readFileForImage(file: File) {
    if (!file) return;
    let self = this;
    let fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    // When the file has loaded, check to see if it's valid
    fileReader.onloadend = function (e: any) {

      // Attempt to load the image
      let image = new Image();
      image.src = e.target.result;

      image.onerror = () => {
        self.toast.error('Invalid file type. Allowed types: .png, .gif, .jpg, .jpeg');
        self.invalidFileType.emit();
      };

      image.onload = () => {
        if (self.maxFileSize > 0 && (e.loaded / 1000) > self.maxFileSize) {
          self.toast.error('Maximum file size exceeded. ' + self.maxFileSize + 'KB allowed.');
          self.maxFileSizeExceeded.emit();
        } else {
          self.broadcastImage(image, file);
        }
      };
    };
  }

  broadcastImage(image: HTMLImageElement, imageFile: File) {
    if (this.cropperName) this.imageService.setImageToBeCropped(image, this.cropperName);
    this.fileDropped.emit(imageFile);
  }

  // Handlers for file drag and drop
  @HostListener('dragover', ['$event'])
  public onDragOver(e: any): void {
    if (this.active) {
      this.dropStateActive = true;
      this.allowDragLeave = false;
      this.preventAndStopEventPropagation(e);
    }
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(e: Event): void {
    if (this.active) {
      this.allowDragLeave = true;
      setTimeout(() => {
        if (this.allowDragLeave) this.dropStateActive = false;
        this.preventAndStopEventPropagation(e);
      }, 100);
    }
  }

  @HostListener('drop', ['$event'])
  public onDrop(e: any) {
    if (this.active) {
      this.dropStateActive = false;
      let files = e.target.files || e.dataTransfer.files;
      if (files.length) this.readFileForImage(files[0]);
      this.preventAndStopEventPropagation(e);
    }
  }

  preventAndStopEventPropagation(e: any) {
    e.preventDefault();
    e.stopPropagation();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/draggable-image-wrapper/draggable-image-wrapper.component.ts